<template>
  <base-modal
    :reference="'planningBusHistoryModal_' + bus.id"
    :title="'Historial envíos bus ' + bus.name"
    :acceptAction="close"
    :cancelActionText="'Cerrar'"
    :size="'md'"
  >
    <template v-slot:body v-if="show">
      <p class="font-weight-bold">Historial de envíos del bus {{bus.name}} para el día {{$moment(bus.day).format('DD-MM-YYYY')}}</p>
        <div v-if="events.length > 0">
          <div v-for="event in events" :key="event.id" class="text-left">
            <p class="mb-1 mt-4">El <em>{{$moment(event.date).format('DD-MM-YYYY HH:MM:SS')}}</em> se envió a:</p>
            <span class="ml-4"> {{event.recipients}} </span>
          </div>
        </div>
        <div v-else>
          Aún no se ha enviado ninguna comunicación para este bus
        </div>
    </template>
  </base-modal>
</template>

<script>
/* eslint-disable */
import { mapGetters } from 'vuex';
import BaseModal from '../Booking/Modal/BaseModal';

export default {
  components: {
      BaseModal,
  },
  props: {
    events: {
      type: Array,
      required: true,
    },
    bus: {
        type: Object,
        required: true
    }
  },
  data() {
    return {
      show: false,
    };
  },
  async mounted() {
    this.$root.$on('bv::modal::show', async (bvEvent, modalId) => {
      if ( modalId === 'planningBusHistoryModal_' + this.bus.id ) {
        this.show = true
      }
    })
  },
  methods: {
      close() {
          this.$bvModal.hide('planningBusHistoryModal_' + this.bus.id);
      }
  }
};
</script>